var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyBuyHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4236 6.88895L16.2986 2.76394C16.1019 2.56732 15.807 2.50957 15.5492 2.61476C15.2921 2.72132 15.125 2.97226 15.125 3.25001V5.31251H4.8125C3.67331 5.31251 2.75 6.23582 2.75 7.37501C2.75 8.51419 3.67331 9.43751 4.8125 9.43751H15.125V11.5C15.125 11.7778 15.2921 12.0287 15.5492 12.1353C15.8077 12.2418 16.1026 12.182 16.2986 11.9861L20.4236 7.86107C20.6924 7.59294 20.6924 7.15707 20.4236 6.88895Z",
    fill: "#D9D2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1874 13.5625H6.8749V11.5C6.8749 11.2223 6.70784 10.9713 6.45071 10.8648C6.19359 10.7582 5.89865 10.8167 5.70134 11.014L1.57634 15.139C1.30821 15.4071 1.30821 15.843 1.57634 16.1111L5.70134 20.2361C5.89728 20.432 6.19221 20.4918 6.45071 20.3853C6.70784 20.2787 6.8749 20.0278 6.8749 19.75V17.6875H17.1874C18.3266 17.6875 19.2499 16.7642 19.2499 15.625C19.2499 14.4858 18.3266 13.5625 17.1874 13.5625Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyBuyHold);
export default __webpack_public_path__ + "static/media/strategy-buy-hold.fd74b95ee83b96a2876997523d1550f1.svg";
export { ForwardRef as ReactComponent };